import React from "react";
import {useHistory} from "react-router-dom";

function RegisterSuccessfulResult() {

    const history = useHistory();

    const login = () => {
        history.push('/login');
    }

    return (
        <div className="text-center">
            <h3>Success!</h3>
            <p>You have been registered successfully! Go to login page and enter your credentials in order to login!</p>
            <a href="" onClick={login}>Login</a>
        </div>

    )
}

export default RegisterSuccessfulResult;